import pt from '../locales/pt';
import { toLocalISODate } from './selfiePeriod';

/**
 * Agrupa despesas por dia (occurred_on), mais recente primeiro.
 */
export function groupExpensesByDay(results = []) {
  const out = new Map();
  results.forEach((expense) => {
    const key = expense.occurred_on;
    if (!out.has(key)) out.set(key, []);
    out.get(key).push(expense);
  });
  return [...out.entries()].sort(([a], [b]) => (a < b ? 1 : -1));
}

/**
 * Soma dos valores de um dia.
 */
export function dayExpenseTotal(items = []) {
  return items.reduce((sum, item) => sum + Number(item.amount || 0), 0);
}

/**
 * Formata hora de registo (created_at ISO).
 */
export function formatExpenseTime(createdAt) {
  if (!createdAt) return '';
  const date = new Date(createdAt);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleTimeString('pt-PT', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * Label de dia para lista de despesas (Hoje, Ontem, ou data formatada).
 */
export function formatExpenseDayLabel(date, referenceDate = new Date()) {
  const today = new Date(referenceDate);
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  if (date === toLocalISODate(today)) return pt.expenses.list.today;
  if (date === toLocalISODate(yesterday)) return pt.expenses.list.yesterday;

  const parts = date.split('-');
  const d = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
  return d.toLocaleDateString('pt-PT', {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
  });
}

/**
 * Label completo do cabeçalho do dia (ex.: «Hoje · Sex 4 Jul»).
 */
export function formatExpenseDayHeader(date, referenceDate = new Date()) {
  const prefix = formatExpenseDayLabel(date, referenceDate);
  const parts = date.split('-');
  const d = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
  const formatted = d.toLocaleDateString('pt-PT', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  });
  const todayIso = toLocalISODate(referenceDate);
  const yesterday = new Date(referenceDate);
  yesterday.setDate(yesterday.getDate() - 1);
  const yesterdayIso = toLocalISODate(yesterday);

  if (date === todayIso || date === yesterdayIso) {
    return `${prefix} · ${formatted}`;
  }
  return formatted;
}
